import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from '@sentry/angular';
import { configureDebugLogger, debugLogger } from '@common-helpers/debug-logger';
import { environment } from './environments/enviroment';

configureDebugLogger(environment.production);

Sentry.init({
    dsn: 'https://05d587205282c5908d215b4bc20dc5bd@o4511347358367744.ingest.de.sentry.io/4511732744257616',
    dataCollection: {
        // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/angular/configuration/options/#dataCollection
        userInfo: true
        // httpBodies: []
    }
});
bootstrapApplication(App, appConfig).catch((err) => debugLogger.error('err', err));
